import {   useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {  getUserDefineds, updateUserDefineds } from "../api.js";
import { useNotification } from "../../../contexts/NotificationContext.js";


export const useGetUserDefineds = () => {
  const {data, isLoading, isError, error, isSuccess} = useQuery({
    queryKey: ['user-defineds'],
    queryFn: () => getUserDefineds(),
  });

  return {data, isLoading, isSuccess, isError, error};
};



export const useUpdateUserDefineds = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: ({ id, data }) => updateUserDefineds(id, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["user-defineds"] });
      // Also refresh any inventory detail caches so UserDefinedTab reflects latest field definitions
      await queryClient.invalidateQueries({ queryKey: ["inventory-detail"] });
      
      // Show success notification
      showNotification('success', 'User defined fields updated successfully!');
    },
    onError: (error) => {
      console.error("Error updating user defined fields:", error);
      
      // Show error notification
      let errorMessage = 'Error updating user defined fields. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      showNotification('danger', errorMessage);
    },
  });
};
